export type TopicReply = {
  id: string;
  author: string;
  time: string;
  content: string;
};

export type TopicItem = {
  id: string;
  title: string;
  author: string;
  authorBio: string;
  createdAt: string;
  replyCount: number;
  participantCount: number;
  lastReplyAt: string;
  category: string;
  excerpt: string;
  content: string[];
  image: string;
  replies: TopicReply[];
};

const topicImage =
  "https://readdy.ai/api/search-image?query=Moody%20dark%20lounge%20table%20with%20two%20glasses%20and%20a%20small%20warm%20lamp%2C%20burgundy%20velvet%20sofa%20in%20the%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=960&height=480&seq=adult-community-01&orientation=landscape";
const topicImage2 =
  "https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20photograph%20of%20light%20and%20shadow%20on%20a%20studio%20wall%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=960&height=480&seq=adult-community-02&orientation=landscape";

export const topicCategories = ["全部", "作品讨论", "观影习惯", "行业话题", "创作交流"];

export const communityTopics: TopicItem[] = [
  {
    id: "t1",
    title: "你更喜欢剧情向还是氛围向的作品？",
    author: "夜航",
    authorBio: "注册于 2024 年 · 发布 42 个话题",
    createdAt: "2026-10-16 23:14",
    replyCount: 128,
    participantCount: 342,
    lastReplyAt: "2026-10-18 21:06",
    category: "作品讨论",
    excerpt:
      "最近把分类页几乎翻了一遍，发现自己的收藏夹里全是没什么台词的短片。想问问大家，你们更吃哪一套？",
    content: [
      "最近把分类页几乎翻了一遍，发现自己的收藏夹里全是没什么台词的短片。剧情向的作品当然好看，但很多时候我只是想放空一下，有画面和声音就够了。",
      "好奇大家的偏好是什么样的。如果只能选一个，你会选结构完整的剧情片，还是氛围先行、情节很淡的那种？",
    ],
    image: topicImage,
    replies: [
      {
        id: "r1",
        author: "灯下",
        time: "2026-10-17 00:22",
        content: "氛围向 +1。白天已经接收太多信息了，晚上真的不想再跟着剧情动脑子。",
      },
      {
        id: "r2",
        author: "弦外",
        time: "2026-10-17 09:40",
        content: "分时候。周末有整块时间就看剧情向，工作日的深夜只看得进去十几分钟的短片。",
      },
      {
        id: "r3",
        author: "白噪音",
        time: "2026-10-17 14:05",
        content: "我比较在意配乐。有些作品画面一般，但声音做得好的话我能反复看很多遍。",
      },
      {
        id: "r4",
        author: "慢热",
        time: "2026-10-18 21:06",
        content: "都看，但收藏的一定是氛围向。剧情片看完会记住情节，氛围向会记住那一刻的感觉。",
      },
    ],
  },
  {
    id: "t2",
    title: "深夜观影，你会开灯吗？",
    author: "灯下",
    authorBio: "注册于 2023 年 · 发布 76 个话题",
    createdAt: "2026-10-14 22:48",
    replyCount: 86,
    participantCount: 210,
    lastReplyAt: "2026-10-18 19:32",
    category: "观影习惯",
    excerpt:
      "看到资讯区那篇讲夜间用眼的文章，突然意识到自己一直是全黑环境。想做个小小的调查。",
    content: [
      "看到资讯区那篇讲夜间用眼的文章，突然意识到自己一直是全黑环境看屏幕，一看就是两三个小时。",
      "试了两天留一盏小夜灯，确实没那么累。想知道大家平时是开灯还是关灯派？",
    ],
    image: topicImage2,
    replies: [
      {
        id: "r1",
        author: "旧胶片",
        time: "2026-10-15 01:12",
        content: "关灯派，但会把屏幕亮度调到最低，然后开着暖色模式。",
      },
      {
        id: "r2",
        author: "夜航",
        time: "2026-10-15 10:28",
        content: "留一盏台灯，放在屏幕侧面。直射和全黑都不太舒服。",
      },
      {
        id: "r3",
        author: "沈医生",
        time: "2026-10-16 08:15",
        content: "从用眼角度建议保留背景光，亮度不要超过屏幕。另外记得每四十分钟看远处放松一下。",
      },
    ],
  },
  {
    id: "t3",
    title: "关于内容分级，大家怎么看",
    author: "白噪音",
    authorBio: "注册于 2022 年 · 发布 118 个话题",
    createdAt: "2026-10-11 16:20",
    replyCount: 214,
    participantCount: 486,
    lastReplyAt: "2026-10-18 22:40",
    category: "行业话题",
    excerpt:
      "资讯区那篇讨论分级制度的文章挺有意思。我个人的观点是，分级越清晰，边界反而越安全。",
    content: [
      "资讯区那篇讨论分级制度的文章挺有意思。我个人的观点是，分级越清晰，边界反而越安全，因为模糊地带才是最难管理的。",
      "但我也理解反对的声音：标签一旦存在，就可能被用来做更精准的检索。问题在于，我们更害怕哪一种风险。",
      "想听听大家的看法，尽量理性讨论，不要互相攻击。",
    ],
    image: topicImage2,
    replies: [
      {
        id: "r1",
        author: "江弥",
        time: "2026-10-12 09:05",
        content: "同意清晰分级的思路，但执行成本很高。小平台很难做到逐条复审。",
      },
      {
        id: "r2",
        author: "慢热",
        time: "2026-10-12 20:11",
        content: "关键是未成年人保护要放在第一位，其他的都可以慢慢讨论。",
      },
      {
        id: "r3",
        author: "夜航",
        time: "2026-10-13 11:47",
        content: "我觉得还要看推荐系统怎么做。分级做得再好，如果推荐一直往边缘推也没意义。",
      },
    ],
  },
  {
    id: "t4",
    title: "求推荐：配乐好听的独立短片",
    author: "弦外",
    authorBio: "注册于 2025 年 · 发布 19 个话题",
    createdAt: "2026-10-09 20:02",
    replyCount: 57,
    participantCount: 138,
    lastReplyAt: "2026-10-17 23:18",
    category: "作品讨论",
    excerpt:
      "最近迷上那种收音很干净、几乎只有环境音的作品。有没有同好，来交换一下片单？",
    content: [
      "最近迷上那种收音很干净、几乎只有环境音的作品。雨声、脚步声、杯子放下的声音，比配乐还抓人。",
      "有没有同好，来交换一下片单？我先把《雨夜私语》和《旧放映厅》放这里。",
    ],
    image: topicImage,
    replies: [
      {
        id: "r1",
        author: "旧胶片",
        time: "2026-10-10 08:30",
        content: "《慢速华尔兹》的配乐值得单独听一遍，钢琴和弦乐层次很清楚。",
      },
      {
        id: "r2",
        author: "灯下",
        time: "2026-10-17 23:18",
        content: "推荐关注一下独立制片分类，里面不少作品的声效做得很讲究。",
      },
    ],
  },
  {
    id: "t5",
    title: "分享：一套很克制的黑白写真",
    author: "影集",
    authorBio: "注册于 2023 年 · 发布 64 个话题",
    createdAt: "2026-10-05 14:36",
    replyCount: 93,
    participantCount: 264,
    lastReplyAt: "2026-10-16 17:02",
    category: "创作交流",
    excerpt:
      "图片区那组《影与褶》真的惊艳到我了，没有人出镜，却处处是身体的痕迹。分享一下我的观感。",
    content: [
      "图片区那组《影与褶》真的惊艳到我了，没有人出镜，却处处是身体的痕迹。",
      "黑白摄影最难的其实是控制灰度，稍微过一点就脏了。这组的暗部保留得很干净，说明布光非常克制。",
      "有没有在拍类似题材的朋友？想聊聊如何用一盏灯完成这种效果。",
    ],
    image: topicImage2,
    replies: [
      {
        id: "r1",
        author: "苏离",
        time: "2026-10-06 10:14",
        content: "谢谢喜欢。那组确实只用了一盏灯加一块黑旗，主要是靠调角度。",
      },
      {
        id: "r2",
        author: "阿岚",
        time: "2026-10-08 21:50",
        content: "黑旗是关键，遮住多余的反光，暗部才会有层次。",
      },
    ],
  },
  {
    id: "t6",
    title: "如何跟伴侣沟通观影偏好",
    author: "慢热",
    authorBio: "注册于 2024 年 · 发布 51 个话题",
    createdAt: "2026-09-30 21:10",
    replyCount: 176,
    participantCount: 402,
    lastReplyAt: "2026-10-15 20:44",
    category: "观影习惯",
    excerpt:
      "这个问题可能有点私人，但我觉得挺重要的。想听听大家是怎么沟通的，以及有没有踩过坑。",
    content: [
      "这个问题可能有点私人，但我觉得挺重要的。两个人偏好不一样是很正常的事，关键在于怎么把话说开。",
      "我自己的经验是，先聊“喜欢什么样的氛围”，而不是直接聊具体内容，会容易很多。",
      "想听听大家是怎么沟通的，以及有没有踩过坑。",
    ],
    image: topicImage,
    replies: [
      {
        id: "r1",
        author: "夜航",
        time: "2026-10-01 09:22",
        content: "同意先聊氛围。直接说类型很容易被误解成某种暗示，反而更难沟通。",
      },
      {
        id: "r2",
        author: "白噪音",
        time: "2026-10-02 22:37",
        content: "底线要提前说清楚，双方都舒服最重要，不用勉强。",
      },
      {
        id: "r3",
        author: "灯下",
        time: "2026-10-15 20:44",
        content: "还有一个细节：不要在同看的时候评价对方的选择，很容易变成争论。",
      },
    ],
  },
];

export const hotTopics = communityTopics.slice(0, 4);